"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Prezi = /** @class */ (function () {
    function Prezi(config) {
        this.providerDisplay = 'Prezi';
        this.providerName = 'prezi';
        this.providerUrl = 'https://prezi.com';
        // tslint:disable-next-line
        this.providerIcon = 'https://assets.prezicdn.net/assets-versioned/coverservice-versioned/1-2a9ca01e3e7dd07bae6c06ff6c795c7e787f9ad4/common/img/favicon.ico?v=2';
        this.type = 'rich';
        this.config = { controls: true };
        this.regex = /(http|https)?:\/\/(prezi\.com\/.*\/.*)/;
        this.config = __assign({}, this.config, config);
    }
    Prezi.prototype.parseData = function (data) {
        var parsedData = __assign({}, data);
        var thumbnailUrl = parsedData.thumbnailUrl, html = parsedData.html;
        if (thumbnailUrl) {
            parsedData.originalThumbnailUrl = thumbnailUrl;
            parsedData.thumbnailUrl = thumbnailUrl.replace('0_0.png', '3_0.png');
        }
        if (html) {
            // Replace controls in html response with the correct setting.
            parsedData.html = html.replace("controls%3D" + (this.config.controls ? '0' : '1'), "controls%3D" + (this.config.controls ? '1' : '0'));
        }
        return parsedData;
    };
    return Prezi;
}());
exports.Prezi = Prezi;
